import { render, staticRenderFns } from "./FormalizacionActas.vue?vue&type=template&id=582f0649&scoped=true"
import script from "./FormalizacionActas.vue?vue&type=script&lang=js"
export * from "./FormalizacionActas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582f0649",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('582f0649')) {
      api.createRecord('582f0649', component.options)
    } else {
      api.reload('582f0649', component.options)
    }
    module.hot.accept("./FormalizacionActas.vue?vue&type=template&id=582f0649&scoped=true", function () {
      api.rerender('582f0649', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/formalizacionactas/FormalizacionActas.vue"
export default component.exports